const exportedObject = {
  consultarPacienteData: {},
  consultarPacienteLoading: false,
  consultarPacienteError: null,

  consultarPacientesData: {},
  consultarPacientesLoading: false,
  consultarPacientesError: null,

  validarHojaQuirurgicaData: {},
  validarHojaQuirurgicaLoading: false,
  validarHojaQuirurgicaError: null,

  consultarEstatusHojasQXData: {},
  consultarEstatusHojasQXLoading: false,
  consultarEstatusHojasQXError: null,

  registrarCoberturaData: {},
  registrarCoberturaLoading: false,
  registrarCoberturaError: null,

  consultarDetalleAnexosData: {},
  consultarDetalleAnexosLoading: false,
  consultarDetalleAnexosError: null,

  consultarDetalleCoberturaData: {},
  consultarDetalleCoberturaLoading: false,
  consultarDetalleCoberturaError: null,
};

export default exportedObject;
